import React, { useState } from 'react';
import { Grid, TextField, Typography, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MenuWithId } from 'components';
import { useEvents } from 'hooks';

const ClearFieldInput = () => {
  const { t } = useTranslation();
  const { setPlan, farmerPlan } = useEvents();
  const [acreUnit] = useState(farmerPlan?.data?.cleared_units || 'acres');

  // temporary hard coded types of clear
  const clearType = [
    { name: t('till'), id: 'till' },
    { name: t('burn'), id: 'burn' },
    { name: t('herbicide'), id: 'herbicide' },
    { name: t('crimp_roll'), id: 'crimp_roll' },
  ];

  const handleAcreageChange = (event) => {
    setPlan({ data: { ...farmerPlan.data, cleared: event.target.value, cleared_units: acreUnit } });
  };

  const handleClearMethodChange = (method) => {
    setPlan({ data: { ...farmerPlan.data, cleared_units: acreUnit, clear_method: method.id } });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('clear_information')}</Typography>
      </CardContent>
      <Grid container>
        <Grid item xs={12} sm={4} padding={2} alignItems="center">
          <Typography variant="subtitle2" gutterBottom component="div">
            {t('select_clear')}
          </Typography>
          <MenuWithId
            placeholder={t('select_clear')}
            menuItems={clearType}
            selectedItem={farmerPlan?.data?.clear_method}
            selectItem={handleClearMethodChange}
            diabled={!clearType || clearType.length === 0}
            size="normal"
          />
        </Grid>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item sm={6}>
            <TextField
              id="acreage"
              label={t('acreage')}
              value={farmerPlan?.data?.cleared}
              placeholder="0"
              onChange={handleAcreageChange}
              type="number"
            />
          </Grid>
          <Grid item sm={2}>
            <Typography style={{ marginLeft: '12px' }} variant="subtitle1" gutterBottom component="div">
              {t(acreUnit)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ClearFieldInput;
